import { Box, Divider, Typography } from "@mui/material";
import { ADGroups } from "./active_directory/ADGroups";
import { OktaGroups } from "./okta/OktaGroups";

const WSU_RED = "#A60F2D";

export const Groups = () => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
      <OktaGroups />
      <Divider />
      <ADGroups />
    </Box>
  );
};
